const isLocal = (location.hostname === "localhost" || location.hostname === "127.0.0.1" || location.hostname === "");

const countryGate = () => {
    if (location.pathname.split("/")[1] === "unsubscribe") {
        return;
    }
    const query = new URLSearchParams(location.search);
    if (localStorage.getItem("country_selected")) {
        if (!query.has("lang")) {
            const defaultLang = localStorage.getItem("default_lang") || "nl";
            if (defaultLang !== "nl") {
                query.set("lang", defaultLang);
                location.href = location.pathname.replace('.html', '') + (isLocal ? '.html' : '') + "?" + query.toString();
            }
        } else {
            localStorage.setItem("default_lang", query.get("lang"));
        }

        return;
    }

    if (query.get("country_selected")) {
        localStorage.setItem("country_selected", "1");
        localStorage.setItem("default_lang", query.get("lang") || "nl");
        return;
    }


    if (location.pathname.split("/")[1].replace('.html', '') !== "country-gate") {
        location.href = "/country-gate" + (isLocal ? '.html' : '');
        return;
    }
};

countryGate();
